// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { DnsRecordSchema } from './DnsRecordSchema'
import type { DnsRecord } from './DnsRecordSchema'
import { DomainEvidenceSchema } from './DomainEvidenceSchema'
import type { DomainEvidence } from './DomainEvidenceSchema'
import { VhostBindingWithRelationsSchema } from './VhostBindingRelationsSchema'
import type { VhostBindingWithRelations } from './VhostBindingRelationsSchema'
import { SoftwareWithRelationsSchema } from './SoftwareRelationsSchema'
import type { SoftwareWithRelations } from './SoftwareRelationsSchema'
import { DomainSchema } from './DomainSchema';

/////////////////////////////////////////
// DOMAIN RELATION SCHEMA
/////////////////////////////////////////

export type DomainRelations = {
  surface: ExternalNetworkWithRelations;
  parent?: DomainWithRelations | null;
  children: DomainWithRelations[];
  dnsRecords: DnsRecord[];
  evidences: DomainEvidence[];
  vhostBindings: VhostBindingWithRelations[];
  software: SoftwareWithRelations[];
};

export type DomainWithRelations = z.infer<typeof DomainSchema> & DomainRelations

export const DomainWithRelationsSchema: z.ZodType<DomainWithRelations> = DomainSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  parent: z.lazy(() => DomainWithRelationsSchema).nullable(),
  children: z.lazy(() => DomainWithRelationsSchema).array(),
  dnsRecords: z.lazy(() => DnsRecordSchema).array(),
  evidences: z.lazy(() => DomainEvidenceSchema).array(),
  vhostBindings: z.lazy(() => VhostBindingWithRelationsSchema).array(),
  software: z.lazy(() => SoftwareWithRelationsSchema).array(),
}))